import React, {ReactNode} from 'react';
import {FLOATING_SIDEBAR_PANEL_CLASS, sx, WIDTH_SIDEBAR_PANEL_DESKTOP} from ".//sx";
import Paper from '@mui/material/Paper';
import HideMode from "./hideMode/HideMode";
import {SetStatePropsType} from "@baseTypes/base";
import {useSearchParams} from 'react-router-dom';
import {getPrevSearchParams} from "@helpers/searchParams/helpers";
import SidebarPanelHeaderUi from "@ui/sidebarPanel/sidebarPanelHeaderUi/SidebarPanelHeaderUi";
import {useMedia} from "@hooks/ui/useMedia";
import Portal from '@mui/material/Portal';
import Drawer from '@mui/material/Drawer';

interface IProps {
    children: ReactNode,
    showSidebar: boolean,
    setShowSidebar: SetStatePropsType<boolean>,
    buttonVariantToggleShow?: 'absolute' | 'static',
    desktopWidth?: string,
    mobileVariant?: 'center' | 'drawer'
    mobileToggleVariant?: 'arrow' | 'fab'
    desktopVariant?: 'column' | 'floating'
}

const SidebarPanelUi = ({
                            children,
                            showSidebar,
                            setShowSidebar,
                            buttonVariantToggleShow,
                            desktopWidth,
                            mobileVariant = 'center',
                            mobileToggleVariant = 'arrow',
                            desktopVariant = 'column',
                        }: IProps) => {

    const {isDesktop} = useMedia()


    const [_, setSearchParams] = useSearchParams()
    const handleChangeShowSidebar = (show: boolean) => {
        setShowSidebar(show)
        setSearchParams(() => {
            return {
                ...getPrevSearchParams(new URLSearchParams(window.location.search)),
                showSidebar: show.toString()
            }
        })
    }


    if (mobileVariant === 'drawer' && !isDesktop) {
        return (
            <>
                {!showSidebar && <HideMode
                    onHideSidebar={() => handleChangeShowSidebar(true)}
                    mobileVariant={mobileToggleVariant}
                />}

                <Drawer
                    anchor={'left'}
                    open={showSidebar}
                    onClose={() => handleChangeShowSidebar(false)}
                    PaperProps={{sx: sx.drawerPaper}}
                >
                    <SidebarPanelHeaderUi
                        onShowSidebar={() => handleChangeShowSidebar(false)}
                        buttonVariantToggleShow={buttonVariantToggleShow}
                    />

                    {children}
                </Drawer>
            </>
        )
    }

    const isFloating = isDesktop && desktopVariant === 'floating'

    if (!showSidebar) {
        return <HideMode
            onHideSidebar={() => handleChangeShowSidebar(true)}
            mobileVariant={mobileToggleVariant}
            floating={isFloating}
        />
    }

    if (!isDesktop) {
        return (
            <Portal>
                <Paper
                    sx={sx.root}
                >
                    <SidebarPanelHeaderUi
                        onShowSidebar={() => handleChangeShowSidebar(false)}
                        buttonVariantToggleShow={buttonVariantToggleShow}
                    />

                    {children}
                </Paper>
            </Portal>
        )
    }

    return (
        <Paper
            sx={{
                ...sx.root,
                width: {
                    xs: '100vw',
                    lg: desktopWidth ?? `${WIDTH_SIDEBAR_PANEL_DESKTOP}px`,
                },
                ...(isFloating ? sx.floating : {}),
            }}
            className={isFloating ? FLOATING_SIDEBAR_PANEL_CLASS : undefined}
        >
            <SidebarPanelHeaderUi
                onShowSidebar={() => handleChangeShowSidebar(false)}
                buttonVariantToggleShow={buttonVariantToggleShow}

            />

            {children}
        </Paper>
    );
};

export default SidebarPanelUi;